/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1BannerBanneridLangs202,
  PostApiV1BannerBanneridLangs400,
  PostApiV1BannerBanneridLangs401,
  PostApiV1BannerBanneridLangs404,
  PostApiV1BannerBanneridLangs500,
  PostApiV1BannerBanneridLangsMutationRequest,
  PostApiV1BannerBanneridLangsMutationResponse,
  PostApiV1BannerBanneridLangsPathParams,
} from "../../types/bannerIdiomasController/PostApiV1BannerBanneridLangs.ts";
import { bannerLangViewModelSchema } from "../bannerLangViewModelSchema.ts";

export const postApiV1BannerBanneridLangsPathParamsSchema = z.object({
  bannerId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1BannerBanneridLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1BannerBanneridLangs202Schema = z.lazy(
  () => bannerLangViewModelSchema,
) as unknown as ToZod<PostApiV1BannerBanneridLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1BannerBanneridLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1BannerBanneridLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1BannerBanneridLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1BannerBanneridLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1BannerBanneridLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1BannerBanneridLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1BannerBanneridLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1BannerBanneridLangs500>;

export const postApiV1BannerBanneridLangsMutationRequestSchema = z.object({
  CultureInfo: z.optional(z.string()),
  Url: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  Image: z.optional(z.instanceof(File)),
  Video: z.optional(z.instanceof(File)),
  ImageMobile: z.optional(z.instanceof(File)),
  VideoMobile: z.optional(z.instanceof(File)),
}) as unknown as ToZod<PostApiV1BannerBanneridLangsMutationRequest>;

export const postApiV1BannerBanneridLangsMutationResponseSchema = z.lazy(
  () => postApiV1BannerBanneridLangs202Schema,
) as unknown as ToZod<PostApiV1BannerBanneridLangsMutationResponse>;
